import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigurationService } from '@services/configuration.service';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ValidateOrderPayload } from './../models/chatbot.interface';
import { CookieStorageService } from './cookie-storage.service';

// @dynamic
@Injectable({
    providedIn: 'root',
})
export class ChatbotService {
    constructor(
        private configurationService: ConfigurationService,
        private httpClient: HttpClient,
        private cookieStorage: CookieStorageService,
    ) {}

    /**
     * Mise à jour de la commande pour rémunération televendeur
     * ne doit pas être bloquant en cas d'erreur
     * @param commandId Id de la commande
     * @returns Observable<any>
     */
    public validateOrder(commandId: string): Observable<any> {
        const url = this.configurationService.getData()?.global.chatbot?.updatecasetlvUrl || null;
        const caseId = this.cookieStorage.get('tc_chatid') || null;

        if (!url || !caseId) {
            return of(null);
        }
        const payload: ValidateOrderPayload = {
            caseId,
            commandId,
        };

        return this.httpClient
            .post(url, payload, { headers: { 'content-type': 'text/plain' } })
            .pipe(catchError(() => of(null)));
    }
}
